// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/unit_scale.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/unit_scale.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_unit_scale: GenFile = /*@__PURE__*/
  fileDesc("CjhxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvdW5pdF9zY2FsZS5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxKr0BCglVbml0U2NhbGUSGgoWVU5JVF9TQ0FMRV9VTlNQRUNJRklFRBAAEhMKD1VOSVRfU0NBTEVfTk9ORRABEhQKEFVOSVRfU0NBTEVfTUlMTEkQAhIUChBVTklUX1NDQUxFX01JQ1JPEAMSEwoPVU5JVF9TQ0FMRV9OQU5PEAQSEwoPVU5JVF9TQ0FMRV9QSUNPEAUSFAoQVU5JVF9TQ0FMRV9GRU1UTxAGEhMKD1VOSVRfU0NBTEVfQVRUTxAHYgZwcm90bzM");

/**
 * Commonly used unit scales
 *
 * @generated from enum quanterix.simoa_one.analysis_app_api.v1.UnitScale
 */
export enum UnitScale {
  /**
   * Unspecified
   *
   * @generated from enum value: UNIT_SCALE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 10E-0 (no scale)
   *
   * @generated from enum value: UNIT_SCALE_NONE = 1;
   */
  NONE = 1,

  /**
   * 10E-3
   *
   * @generated from enum value: UNIT_SCALE_MILLI = 2;
   */
  MILLI = 2,

  /**
   * 10E-6
   *
   * @generated from enum value: UNIT_SCALE_MICRO = 3;
   */
  MICRO = 3,

  /**
   * 10E-9
   *
   * @generated from enum value: UNIT_SCALE_NANO = 4;
   */
  NANO = 4,

  /**
   * 10E-12
   *
   * @generated from enum value: UNIT_SCALE_PICO = 5;
   */
  PICO = 5,

  /**
   * 10E-15
   *
   * @generated from enum value: UNIT_SCALE_FEMTO = 6;
   */
  FEMTO = 6,

  /**
   * 10E-18
   *
   * @generated from enum value: UNIT_SCALE_ATTO = 7;
   */
  ATTO = 7,
}

/**
 * Describes the enum quanterix.simoa_one.analysis_app_api.v1.UnitScale.
 */
export const UnitScaleSchema: GenEnum<UnitScale> = /*@__PURE__*/
  enumDesc(file_quanterix_simoa_one_analysis_app_api_v1_unit_scale, 0);

